import { render } from "./LessonAccessesPage.vue?vue&type=template&id=bdc17d52"
import script from "./LessonAccessesPage.vue?vue&type=script&lang=js"
export * from "./LessonAccessesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__